import MedianRentByBedroom from '../../models/MedianRentByBedroom';
import assign from 'lodash/assign';
import constants from '../constants';

const initState = () =>
  new MedianRentByBedroom({
    studioMedianRent: null,
    oneBedroomMedianRent: null,
    twoBedroomMedianRent: null,
    threeBedroomMedianRent: null,
    fourPlusBedroomMedianRent: null,
  });

// used for FAQ
export const medianRentByBedroom = (state = initState(), action) => {
  const { type, payload } = action;

  if (type === constants.SET_MEDIAN_RENT_BY_BEDROOM) {
    return assign({}, state, payload);
  }
  return state;
};
